import React from 'react';
import PropTypes from 'prop-types';
import cancelEvent from '../../../../services/mini/cancelEvent';
import formats from '../../../../const/formats';
import moment from 'moment';

class VersionTagItem extends React.Component {

    onDisabledDeleteIconClick = (e) => {
        cancelEvent(e);
    }

    onEdit = (e) => {
        const {
            tag,
        } = this.props;
        this.props.onEdit(tag.tagId, e);
    }

    onDelete = (e) => {
        const {
            tag,
        } = this.props;
        this.props.onDelete(tag.tagId, e);
    }

    render() {
        const {
            tag,
            onDelete,
            inList,
            prodTagId,
            selectedTagId,
            stageTagId,
            testingTagId,
        } = this.props;

        let isLast = false,
            mainClass = 'version-tag-item',
            tagName = tag.message;

        if (tagName && tagName.toLowerCase() === 'last') {
            tagName = 'Last';
            isLast = true;
        }
        if (isLast) {
            mainClass += ' last';
        }

        const createTsDate = new Date(+tag.createTs);
        const isCurrentYear = createTsDate.getFullYear() === (new Date()).getFullYear();

        return (
            <div className={mainClass}>
                <div className="version-tag-item_content">
                    <div className={`version-tag-item_value`}>
                        <span title={tagName}>
                            {tagName}
                        </span>
                        {(!isLast) &&
                            <i className="icon icon-alan-lock-small" />}
                    </div>
                    {
                        !isLast &&
                        <div className="version-tag-item_ts">
                            {moment(createTsDate).format(
                                isCurrentYear ?
                                    formats.MMM_DD_hh_mm_a :
                                    formats.MMM_DD_YYYY_hh_mm_a)}
                        </div>
                    }
                </div>
                {(!isLast && inList) &&
                    <div className="version-tag-item_actions">
                        <i className="icon icon-alan-edit version-tag-action-icon" onClick={this.onEdit} />
                        {(onDelete && (prodTagId !== tag.tagId && selectedTagId !== tag.tagId && prodTagId !== tag.tagId && stageTagId !== tag.tagId && testingTagId !== tag.tagId)) ?
                            <i className={`icon icon-alan-trash version-tag-action-icon`}
                                onClick={this.onDelete} /> :
                            <div
                                data-for="deleteTagIsDisabled"
                                data-tip="You cannot delete version that is running on Production"
                                data-place="bottom"
                                data-effect="solid"
                                data-class="tutor-light-tooltip tutor-no-arrow-tooltip">
                                <i className={`icon icon-alan-trash version-tag-action-icon inactive`}
                                    onClick={this.onDisabledDeleteIconClick} />
                            </div>
                        }
                    </div>}
            </div>
        );
    }
}

VersionTagItem.propTypes = {
    tag: PropTypes.object.isRequired,
    selectedTagId: PropTypes.string.isRequired,
    prodTagId: PropTypes.string.isRequired,
    testingTagId: PropTypes.string.isRequired,
    stageTagId: PropTypes.string.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func
};

export default VersionTagItem;
